import { CellContext } from '@tanstack/react-table'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { OrgPositionsTableRow } from '../data'
import { useModalContext } from 'src/design-system'
import {
  POSITION_MODAL_ID,
  PositionModalProps,
} from 'components/position-modal/utils'
import { Warning } from '@phosphor-icons/react'
import { store } from 'store/index'

export const NameCell = observer(
  (data: CellContext<OrgPositionsTableRow, unknown>) => {
    const row = data.row.original
    const { openModal } = useModalContext()

    const handleClick = () => {
      openModal<PositionModalProps>(POSITION_MODAL_ID, {
        positionId: row.id.toString(),
        source: 'org_positions_table',
      })
    }

    return (
      <div className="flex gap-x-2 items-center">
        <div
          className="border border-white bg-image-cover flex-shrink-0 h-8 rounded w-8"
          style={{ backgroundImage: `url("${row.imageUrl}")` }}
        />

        <button
          onClick={handleClick}
          className="font-bold text-gray-900 text-sm flex gap-3 hover:underline text-left"
        >
          {row.name}
          {row.hasIssues &&
            store.currentUser?.org?.enableHealthAudit &&
            store.currentUser?.isAdmin && (
              <Warning
                size={16}
                className="text-gray-500 shrink-0"
                weight="bold"
              />
            )}
        </button>
      </div>
    )
  }
)
